import { EnvironmentStatus } from "../models/environment-status";
import { Selector } from "@ngrx/store";

interface AppState {
    environmentStatus: EnvironmentStatus | null;
}

export const status: Selector<AppState, EnvironmentStatus | null> = (state: AppState) => state.environmentStatus;
